// @flow
import React from 'react';
import styles from './CompanySummary.less';
import { Text } from 'seek-style-guide/react';
import { get } from 'lodash';

type Props = {
  canonicalCompany?: Description
};

const CompanySummary = ({ canonicalCompany }: Props) => {
  const companyName = get(canonicalCompany, 'description');
  if (companyName) {
    return (
      <div className={styles.root}>
        <Text headline data-automation={'company-serp-job-at'}>
          Jobs at {companyName}
        </Text>
      </div>
    );
  }

  return null;
};

export default CompanySummary;
